module.exports = __webpack_public_path__ + "img/2018-11-04.ebcc380b.jpg";